import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import auth from "../../../common/utility/auth";
import { VER_ALL_CRDTO_ASE } from '../../../common/types/configuracionType';

class Filters extends React.Component {

    clsAlphaNoOnly(e) {  // Accept only alpha numerics, no special characters 
        var regex = new RegExp("^[a-zA-Z0-9 ]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }

        e.preventDefault();
        return false;
    }
    render() {

        var flagVerAll  = this.props.configuraciones.filter((m) => m.abreviatura === VER_ALL_CRDTO_ASE).length >= 1 ? false : true;

        return (
            <div className="filfer-container">
                {this.props.visibleDetalle ?

                    <Row gutter={16}>
                        <Col className="gutter-row" sm={24} md={12} lg={8}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idCliente ?
                                        { key: this.props.filter.idCliente } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por cliente" />}
                                disabled
                        
                            >
                                {this.props.lista_clientes.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id} name={item.tipoDocumentoNombre} > <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.nroContrato}
                                onChange={(e) => this.props.onChange("nroContrato", e.target.value)}
                                disabled
                                placeholder="Filtrar por nro Contrato"
                                autoComplete="off"
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idEstado ?
                                        { key: this.props.filter.idEstado } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                                onChange={(option) => this.props.onChange("idEstado", option.key, option, 'estado')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.estadoDetalle.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                    </Row> :

                    <Row gutter={16}>


                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idEstablecimiento ?
                                        { key: this.props.filter.idEstablecimiento } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Establecimiento" />}
                                onChange={(option) => this.props.onChange("idEstablecimiento", option.key, option, 'idEstablecimiento')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.establecimientos.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={8}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idCliente ?
                                        { key: this.props.filter.idCliente } : undefined
                                }
                                disabled={this.props.isDisabled}
                                placeholder={<SelectPlaceHolder label="Filtrar por cliente" />}
                                onChange={(e) => this.props.onChange("idCliente", e.key)}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.lista_clientes.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id} name={item.tipoDocumentoNombre} > <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                                ))}
                            </Select>
                        </Col>


                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idTipoCredito ?
                                        { key: this.props.filter.idTipoCredito } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Tipo Crédito" />}
                                onChange={(option) => this.props.onChange("idTipoCredito", option.key, option, 'idTipoCredito')}
                                optionFilterProp="children"
                            >
                                {this.props.tipoCredito.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={6}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idVendedor ?
                                        { key: this.props.filter.idVendedor } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Asesor" />}
                                onChange={(option) => this.props.onChange("idVendedor", option.key, option, 'idVendedor')}
                                optionFilterProp="children"
                                disabled={flagVerAll}
                            >
                                {this.props.vendedores.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}><Tag>{item.tipoDocumentoNombre}</Tag>{item.razonSocialEntidad}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.nroContrato}
                                onChange={(e) => this.props.onChange("nroContrato", e.target.value)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por nro Contrato"
                                autoComplete="off"
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idEstado ?
                                        { key: this.props.filter.idEstado } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                                onChange={(option) => this.props.onChange("idEstado", option.key, option, 'estado')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                {this.props.estado.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                disabled={flagVerAll}
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.serie}
                                onChange={(e) => this.props.onChange("serie", e.target.value)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por serie"
                                autoComplete="off"
                            />
                        </Col>
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.documento}
                                onChange={(e) => this.props.onChange("documento", e.target.value)}
                                onKeyUp={this.props.onKeyUpSearch}
                                placeholder="Filtrar por documento"
                                autoComplete="off"
                            />
                        </Col>
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha inicio"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                            />
                        </Col>
                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <DatePicker
                                placeholder="Filtrar por fecha fin"
                                format="DD/MM/YYYY"
                                value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                                onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                            />
                        </Col>

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idProyecto ?
                                        { key: this.props.filter.idProyecto } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                                onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                <Select.Option value="0" key="0">TODOS</Select.Option>
                                {this.props.proyectos.map(item => ( //STATE DATA

                                    <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                                ))}
                            </Select>
                        </Col>
                    </Row>

                }

            </div>
        );
    }

}

export default Filters;